var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"content-load",class:{ 'full-loading': !_vm.template }},[_c('base-loading',{attrs:{"color":"#6161ff"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }